// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { Shape } from '../../../types';
import Point from './Point';

const useStyles = makeStyles(theme => ({
    th: {
        paddingLeft: 4,
        paddingRight: 4,
    },
}));

type Props = $ReadOnly<{
    name: string,
    points: $ReadOnlyArray<[number, number]>,
    minLength?: number,

    inputChange: (name: string, value: mixed) => void,
    removePoint: (index: number) => void,
    onPointChange?: (index: number, point: [number, number]) => void
}>;

const Points = ({ name, points, minLength, inputChange, removePoint, onPointChange }: Props) => {
    const classes = useStyles();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell size="small" padding="none">#</TableCell>
                    <TableCell size="small" padding="none" className={classes.th}>
                        <FormattedMessage
                            id="lat"
                            defaultMessage="Lat"
                        />
                    </TableCell>
                    <TableCell size="small" padding="none" className={classes.th}>
                        <FormattedMessage
                            id="lon"
                            defaultMessage="Lon"
                        />
                    </TableCell>
                    <TableCell size="small" padding="none" />
                </TableRow>
            </TableHead>
            <TableBody>
                {points.map((point, index) => (
                    <Point
                        key={index}
                        index={index}
                        name={`${name}[${index}]`}
                        point={point}
                        removable={!minLength || points.length > minLength}
                        inputChange={inputChange}
                        removePoint={removePoint}
                        onChange={onPointChange}
                    />
                ))}
            </TableBody>
        </Table>
    )
};

export default Points